import { ChevronRight } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

function PurchaseOrderToolbar({ activeView, onChangeView }) {
  const scrollRef = useRef(null);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const actions = [
    { id: 'list', label: 'P.O. List' },
    { id: 'create', label: 'Add P.O.' },
    { id: 'supplier-batch', label: 'Initial Summary P.O.' },
    { id: 'supplier-balancing', label: 'Supplier Balancing' },
    { id: 'reject-history', label: 'Reject History' },
  ];

  useEffect(() => {
    const scrollElement = scrollRef.current;

    if (!scrollElement) {
      return undefined;
    }

    function updateScrollHint() {
      const remainingScroll =
        scrollElement.scrollWidth - scrollElement.clientWidth - scrollElement.scrollLeft;

      setCanScrollRight(remainingScroll > 2);
    }

    updateScrollHint();
    scrollElement.addEventListener('scroll', updateScrollHint, { passive: true });
    window.addEventListener('resize', updateScrollHint);

    return () => {
      scrollElement.removeEventListener('scroll', updateScrollHint);
      window.removeEventListener('resize', updateScrollHint);
    };
  }, [actions.length]);

  return (
    <div className="relative min-w-0 max-w-full overflow-hidden sm:w-fit">
      <div
        ref={scrollRef}
        className="inline-flex w-full max-w-full gap-1 overflow-x-auto rounded-[18px] border border-[var(--theme-border)] bg-[var(--theme-accent-soft)] p-1 pr-11 shadow-[inset_0_1px_0_rgba(255,255,255,0.68)] [scrollbar-width:none] [-ms-overflow-style:none] sm:w-fit sm:pr-1 [&::-webkit-scrollbar]:hidden"
      >
        {actions.map((action) => {
          const isActive = action.id === activeView;

          return (
            <button
              key={action.id}
              className={`inline-flex min-h-[44px] shrink-0 items-center justify-center rounded-[14px] px-5 text-[0.94rem] font-semibold outline-none transition focus-visible:ring-2 focus-visible:ring-[var(--theme-focus)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--theme-app-bg)] sm:px-6 ${
                isActive
                  ? 'bg-white text-[var(--theme-text)] shadow-[0_10px_22px_rgba(var(--theme-shadow-rgb),0.12)] ring-1 ring-[var(--theme-accent)]'
                  : 'text-[var(--theme-accent-strong)] hover:bg-white/65 hover:text-[var(--theme-text-strong)]'
              }`}
              type="button"
              onClick={() => onChangeView(action.id)}
              aria-pressed={isActive}
            >
              {action.label}
            </button>
          );
        })}
      </div>
      {canScrollRight ? (
        <div
          className="pointer-events-none absolute bottom-0 right-0 top-0 flex w-14 items-center justify-end rounded-r-[18px] bg-[linear-gradient(90deg,rgba(216,240,241,0),var(--theme-accent-soft)_42%,var(--theme-accent-soft)_100%)] pr-2 sm:hidden"
          aria-hidden="true"
        >
          <span className="grid h-8 w-8 place-items-center rounded-full border border-[var(--theme-border)] bg-white text-[var(--theme-accent)] shadow-[0_6px_14px_rgba(var(--theme-shadow-rgb),0.1)]">
            <ChevronRight className="h-4 w-4" />
          </span>
        </div>
      ) : null}
    </div>
  );
}

export default PurchaseOrderToolbar;
